module.exports = __webpack_public_path__ + "static/arte_saber-840c2fe74d92055ea90aaeedd618a611.jpeg";